// Decodes HTML entities (e.g. &amp;) returned by the backend; textContent keeps it inert.
export function decodeHtmlEntities(text: string): string {
    if (!text || !text.includes("&")) return text;
    return new DOMParser().parseFromString(text, "text/html").documentElement.textContent ?? text;
}
